import { render, staticRenderFns } from "./Annotation.vue?vue&type=template&id=22cb2b9f&scoped=true&"
import script from "./Annotation.vue?vue&type=script&lang=js&"
export * from "./Annotation.vue?vue&type=script&lang=js&"
import style0 from "./Annotation.vue?vue&type=style&index=0&id=22cb2b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb2b9f",
  null
  
)

component.options.__file = "Annotation.vue"
export default component.exports